
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es/seo_pages/[...path]",
      function () {
        return require("private-next-pages/es/seo_pages/[...path].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es/seo_pages/[...path]"])
      });
    }
  